<template>
	<div class="claimOrder">
		<div  class="home-box">
			<Dialog :LogisticsWindow.sync="LogisticsWindow" ></Dialog>
			<div>
				<div class="home-title">
					<div style="display: flex;font-size:18px;align-items:center;padding:0 15px">
						{{$t('other.a2257')}}
					</div>
				</div>
				<div class="titl_desc_tip">
					<div v-if="!isShopsooo">
						<video id="xttblog" 
						controls preload="auto" width="640" height="264"
						src="../../assets/video/v5.mp4"
						
						data-setup='{"example_option":true}'>
						</video>

					</div>
					<div class="titl_desc_tip_right">
						<p style="line-height:28px"><span style="font-weight:bold">{{$t('other.a414')}}：</span>{{$t('other.a2260')}}</p>
						<p style="line-height:28px"> <span style="font-weight:bold">{{$t('other.a2258')}}：</span>{{$t('other.a2261')}}</p>
						<p style="line-height:28px"><span style="font-weight:bold">{{$t('other.a2259')}}：</span>{{$t('other.a2262')}}</p>
						<p style="line-height:28px">{{$t('other.a2263')}}</p>
					</div>
				</div>
				<div class="home-box-ttp">
                    <div :class="{'home-box-item-childern':true,'home-box-item-childern-active':params.type == 0}" @click="viewMore(0)">
                        <div class="home-box-item-childern-header" >
                            <div >
                                <span style="padding-right:15px">{{$t('other.a2264')}}-{{$t('other.a52')}}</span>
                            </div>
                            <div style="display: flex;">
                                
                                <div style="display: flex;cursor: pointer;">
                                    <el-tooltip   effect="light" :content="$t('other.a2265')" placement="bottom">
                                    <div class="item-header-right01">?</div>
                                    </el-tooltip>
                                </div>
                                
                            </div>
                        </div>
                        <div class="home-box-item-childern-content">
                            <span>{{$t('other.a381')}}：{{toComfirmClaimtotal}}</span>
                            <span style="margin-left: 30px;">{{$t('other.a77')}}：{{Amount01.toFixed(2)}}</span>
                        </div>
                    </div>
                    <div  :class="{'home-box-item-childern':true,'home-box-item-childern-active':params.type == 1}" @click="viewMore(1)">
                        <div class="home-box-item-childern-header">
                            <div>
                                <span style="padding-right:15px">{{$t('other.a2269')}}-{{$t('other.a52')}}</span>
                            </div>
                            <div style="display: flex;">
                                
                                <div style="display: flex;cursor: pointer;">
                                    <el-tooltip   effect="light" :content="$t('other.a2266')" placement="bottom">
                                    <div class="item-header-right01">?</div>
                                    </el-tooltip>
                                </div>
                                
                            </div>
                        </div>
                        <div class="home-box-item-childern-content">
                            <span>{{$t('other.a381')}}：{{Claimtotal}}</span>
                            <span style="margin-left: 30px;">{{$t('other.a77')}}：{{Amount02.toFixed(2)}}</span>
                        </div>
                    </div>
                    <div :class="{'home-box-item-childern':true,'home-box-item-childern-active':params.type == 2}" @click="viewMore(2)">
                        <div class="home-box-item-childern-header">
                            <div>
                                <span style="padding-right:15px">{{$t('other.a135')}}-{{$t('other.a52')}}</span>

                            </div>
                            
                            <div style="display: flex;">
                                
                                <div style="display: flex;cursor: pointer;">
                                    <el-tooltip   effect="light" :content="$t('other.a2267')" placement="bottom">
                                    <div class="item-header-right01">?</div>
                                    </el-tooltip>
                                </div>
                                
                            </div>
                        </div>
                        <div class="home-box-item-childern-content">
                            <span>{{$t('other.a381')}}：{{hasClaimtotal}}</span>
                            <span style="margin-left: 30px;">{{$t('other.a77')}}：{{Amount03.toFixed(2)}}</span>
                        </div>
                    </div>
				</div>

                <div style="width: 100%;padding:0 15px">
				<span>{{$t('other.a70')}}</span>
				<el-select  v-model="storesvalue" @change="getClaimOrder" :placeholder="$t('other.a50')">
					<el-option v-for="item in Allstores" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
				<!-- <span v-if="params.type === 0" style="margin-left: 12px;">{{$t('other.a71')}}</span>
				<el-select v-if="params.type === 0"  v-model="returnCasuevalue" @change="getClaimOrderCopy" :placeholder="$t('other.a50')">
					<el-option v-for="item in returnCasue" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select> -->
				<el-button style="margin-left: 15px;color: orangered;" type="text" @click="exportExcel(0)">{{$t('other.a72')}}</el-button>
				<el-button style="margin-left: 15px;color: orangered;" type="text" @click="exportExcel(1)">{{$t('other.a73')}}</el-button>
				<el-button v-if="params.type === 0" style="margin-left: 15px;color: orangered;" type="text" @click="fullClaim()">{{$t('other.a74')}}</el-button>
				<el-tooltip v-if="params.type === 0" style="margin-left:20px"  effect="light" :content="$t('other.a75')" placement="bottom">
				<i class="el-icon-question" style="font-size:22px"></i>
				</el-tooltip>
				
			</div>
            <div style="text-align:center;font-size:25px">{{params.type | filterDesc}}</div>
            <div style="padding:10px">
                <el-table border :data="claimlist"   @selection-change="handleSelectionChange">
					<el-table-column :label="$t('other.a29')" type="selection" width="55">
					</el-table-column>
					<el-table-column :label="$t('other.a60')">
						<template slot-scope="props">
							<span>{{props.row.orderId}}</span>
						</template>
					</el-table-column>
                    <el-table-column :label="$t('other.a838')">
						<template slot-scope="props">
							<span>{{showShopName(props.row.shopId)}}</span>
						</template>
					</el-table-column>
					<el-table-column :show-overflow-tooltip="true"  :label="$t('other.a76')">
						<template slot-scope="props">
							<span>{{returnCause(props.row.returnCause)}}</span>
						</template>
					</el-table-column>
					<el-table-column :label="$t('other.a77')" >
						<template slot-scope="props">
							<span>{{props.row.returnAmount}}</span>
						</template>
					</el-table-column>
					<el-table-column :label="$t('other.a78')" v-if="params.type== 0 || params.type==1" :show-overflow-tooltip="true">
						<template slot-scope="props">
							<span>{{getTime(props.row.createTime)}}</span>
						</template>
					</el-table-column>
					<el-table-column :label="$t('other.a79')" v-if="params.type== 2 " :show-overflow-tooltip="true">
						<template slot-scope="props">
							<span>{{getTime(props.row.createTime)}}</span>
						</template>
					</el-table-column>
					<el-table-column :label="$t('other.a80')" :show-overflow-tooltip="true" v-if="params.type== 0">
						<template slot-scope="props">
							<span style="color: red;">{{remainTime(props.row.createTime)}}</span>
						</template>
					</el-table-column>
					<el-table-column :show-overflow-tooltip="true" :label="$t('other.a33')" width="250">
						<template slot-scope="props">
							<span v-if="params.type== 0" style="cursor: pointer;font-size:12px;color:#409EFF ;" @click="auditClaim(props.row)">{{$t('other.a81')}}</span>
							<span v-if="params.type== 0" style="cursor: pointer;font-size:12px;color:#409EFF ;padding-left: 15px;" @click="giveUp_Claim(props.row,props.$index)">{{$t('other.a2270')}}</span>
							<span v-if="params.type== 0" style="cursor: pointer;font-size:12px;color:#409EFF ;padding-left: 15px;" @click="viewLogistics01(props.row)">{{$t('other.a82')}}</span>
							<el-tooltip style="padding-right:5px"   effect="light" :content="$t('other.a2268')" placement="bottom">
                                <span v-if="params.type== 1" style="cursor: pointer;font-size:12px;color:#409EFF ;padding-left: 15px;">{{$t('other.a83')}}</span>
                             </el-tooltip>
							<span v-if="params.type== 2" style="cursor: pointer;font-size:12px;color:#409EFF ;padding-left: 15px;color: red;">{{$t('other.a84')}}</span>
						</template>
					</el-table-column>
				</el-table>
            </div>
            <!-- 分页器 -->
				<div class="Pager">
					<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="currentPage1"
					:page-sizes="[15, 50, 100, 200]"
					:page-size="params.offset"
					layout=" total,sizes, prev, pager, next, jumper"
					:total="claimlisttotal">
					</el-pagination>
				  </div>
			</div>
		</div>
	</div>
	
</template>

<script>
	import { mapState, mapActions, mapMutations} from 'vuex'
	import Dialog from '../../components/dialog/dialog.vue'
	import api from '../../api/moudles/shopaccess'
	import orderApi from '../../api/moudles/order'
	import echarts from 'echarts'
	import utils from '../../utils/utils.js'
import newOrders from '../../api/moudles/newOrders'
import i18n from '@/i18n/i18n'
	export default{
		data(){
			return {
				warehouselist:JSON.parse(localStorage.getItem('warehouse')) || ' ',
				shopeeShoplist:JSON.parse(localStorage.getItem('shopIdInfo')) || ' ',
				shophasAuthorization:JSON.parse(localStorage.getItem('shophasAuthorization')),
				isShopsooo:JSON.parse(localStorage.getItem('isShopsooo')),
                Allstores:[],
				chartsline:null,
				onlyStoreItem:false,
				claimdatatype:null,
				salesVisible:false,
                LogisticsWindow:false,
				salesVisible01:false,
				value4:'',
				Claimpopup:false,
				allshopId:[],
                shopIdlist:[],
				showPage:false,
				pointsInfomation:[],
				pointsInfomationNum:0,
				setPassword:false,
                currentPage1:1,
				SecondPWSVisible:false,
                multipleSelection:[],
				secondPws:'',
				shopName:'',
                returnCasuevalue:'',
                returnCasue: [{
					value: 0,
					label: this.$t("other.a113")
				}, {
					value: 5,
					label: this.$t("other.a114")
				}, {
					value: 4,
					label: this.$t("other.a115")
				}, ],
				kilogram:'',
				storeName:'',
				days01:null,
				pickerOptions2: {
				          shortcuts: [{
				            text: this.$t("other.a130"),
				            onClick(picker) {
				              const end = new Date();
				              const start = new Date();
				              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
				              picker.$emit('pick', [start, end]);
				            }
				          }, {
				            text: this.$t("other.a131"),
				            onClick(picker) {
				              const end = new Date();
				              const start = new Date();
				              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
				              picker.$emit('pick', [start, end]);
				            }
				          }, {
				            text: this.$t("other.a132"),
				            onClick(picker) {
				              const end = new Date();
				              const start = new Date();
				              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
				              picker.$emit('pick', [start, end]);
				            }
				          }]
				},
                params:{
                    offset:50,
                    page:0,
                    shopIds:[],
                    type:0,
                    userId:null,
                }
			}
		},
		computed:{
			...mapState({
				userId: state=>state.login.userInfo.userId || '',
				warehouse: state => state.shopaccess.warehouse || '',
				userPos: state=>state.login.userInfo.userPos || '',
				hasSecPw: state=>state.login.userInfo.hasSecPw || '',
				Successed: state=>state.shopaccess.Successed,
				sistemAllstore: state=>state.shopaccess.sistemAllstore,
				lazadashopinfo: state=>state.shopaccess.lazadashopinfo,
				allShopSales: state=>state.shopaccess.allShopSales,
				allWarehouseSales: state=>state.shopaccess.allWarehouseSales,
				allStoreCargovalue: state=>state.shopaccess.allStoreCargovalue,
				allshipCostAmount: state=>state.shopaccess.allshipCostAmount,
				salestotal: state=>state.shopaccess.salestotal,
				salesquentity: state=>state.shopaccess.salesquentity,
				cost:state=>state.shopaccess.cost,
				shopSales:state=>state.shopaccess.shopSales,
				warehouseSales:state=>state.shopaccess.warehouseSales,
				toComfirmClaimtotal:state=>state.shopaccess.toComfirmClaimtotal,
				Claimtotal:state=>state.shopaccess.Claimtotal,
                claimlist: state => state.shopaccess.claimlist,
				hasClaimtotal:state=>state.shopaccess.hasClaimtotal,
				Amount01:state=>state.shopaccess.Amount01,
				Amount02:state=>state.shopaccess.Amount02,
				Amount03:state=>state.shopaccess.Amount03,
				secondPassword:state=>state.shopaccess.secondPassword,
                claimlisttotal: state => state.shopaccess.claimlisttotal,
				
				
				
			}),
			
			show(){
				if(this.hasSecPw){
					return  this.secondPassword
				}else{
					return true
				}
				
			},

          
			
			
			
			allStoreCargovalueCopy(){
				return this.allStoreCargovalue.toFixed(2)
			},
			
			salestotal01(){
				return this.salestotal.toFixed(2)
			},
			grossprofit(){
				let oop=this.salestotal - this.cost
				return oop.toFixed(2)
			},
			//毛利率
			grossmargin() {
				let ttp =(this.salestotal - this.cost)/this.salestotal
				let ccp=ttp*100
				return ccp ? ccp.toFixed(2) + '%' : '0'
			},
			//运输费用
			Transportation() {
				let ccp=this.allshipCostAmount
				return ccp.toFixed(2)
			},
		},
		components:{
			Dialog
		},
        filters:{
            filterDesc:function(value){
                const obj={
                    '0':i18n.t('other.a2271'),
                    '1':i18n.t('other.a2272'),
                    '2':i18n.t('other.a2273'),
                }

                return obj[value]
            }
        },
		created(){
			
			// this.otnmgv()
			this.init()
			// this.getCargovalueByStore()
			// this.getOpp()
			// this.getDaysBetween()


			this.getClaim()
            this.getshop()
            this.params.type=0
            this.getReturnOrder(this.params)
			
		
		},
		methods:{
			...mapActions('shopaccess',[
				'getShopSale',
				'getStoreSale',
				'getCargovalueStore',
				'getReturnOrder',
				'getLockShopID',
				'verifySecondyPassword',
				'getSellerPoint',
                'auditReturn',
              
				

				
			]),

            	...mapActions('order', [

				'viewLogistics',
				


			]),
			...mapActions('recharge', [
				'createPayorderBywechat',
				'OrderTracking',
				'pointChange',
				'getSellerPoint'
			
			]),
			
			...mapMutations('shopaccess', [
				'GET_TTO_CCP',
				'RESET_SECOND_PASSWORD'
			]),

            getshop() {
				this.Allstores = utils.getAllshop()
				if(this.Allstores){
					this.Allstores.forEach(p => {
						if (p.value) {
							this.shopIdlist.push(p.value)
						}
					})
					
				}
			},

              auditClaim(item) {
               this.$confirm(this.$t('other.a2274') + item.orderId+' ?',this.$t("other.a142"),{
                    confirmButtonText:this.$t('other.a235'),
                    cancelButtonText: this.$t('other.a146'),
                    type: 'warning'
                }).then(() => {
                    console.log(item)
                    let arr=[]
                    arr.push(item.orderId)
                    console.log(arr)
                    this.auditReturn(arr).then(res => {
                        console.log('res1111',res)
                        if(res === 200) {
                            this.getReturnOrder(this.params)
                        }
                    })
                })
			},

			giveUp_Claim(item,index){
				this.$confirm(this.$t('other.a2275') + item.orderId+this.$t('other.a2276'),this.$t("other.a142"),{
                    confirmButtonText:this.$t('other.a235'),
                    cancelButtonText: this.$t('other.a146'),
                    type: 'warning'
                }).then(() => {
					let arr=[]
                    arr.push(item.orderId)
					newOrders
					.unReturnOrderAll(arr)
					.then(res => {
					if(res.code === 200 ){
					console.log('desc',res.data)
					this.$message.success(this.$t('other.a2277'))
					this.claimlist.splice(index,1)
					}else{
					this.$message.warning(res.msg)
					}
					})
                })
			},

            fullClaim(){ //点击全部索赔，显示弹窗
                let num=this.claimlist.length
                this.$confirm(this.$t('other.a2278') + num +this.$t('other.a2279'),this.$t("other.a142"),{
                    confirmButtonText:this.$t('other.a235'),
                    cancelButtonText: this.$t('other.a146'),
                    type: 'warning'
                }).then(() => {
                   
                    let arr=this.claimlist.map(p => {return p.orderId})
                    api
                    .auditReturn(arr)
                    .then(res => {
                        if(res.code === 200){
                            this.$message.success(this.$t('other.a2280'))
                            setTimeout(() => {
                                this.getReturnOrder(this.params)
                            },300)
                        }else{
                            this.$message.warning(res.msg)
                        }
                    })
                })
				// this.flag=true
				// this.dialogVisible=true
				// this.getReturnOrder({
				// 			offset: this.claimlisttotal + 1,
				// 			page: 0,
				// 			shopIds: this.shopIdlist,
				// 			type: this.returnCasuevalue,
				// 			userId: this.userId,
				// 			exportXml: 3
				// 		})
			},


            exportExcel(num) {
                const desc={
                    '0':this.$t("other.a133"),
                    '1':this.$t('other.a2281'),
                    '2':this.$t('other.a2282'),
                }
                
				if (num === 1) {
					let params = {}
					if (this.params.type == 0) {
						params = {
							offset: this.claimlisttotal + 1,
							page: 0,
							shopIds: this.shopIdlist,
							type: this.returnCasuevalue,
							userId: this.userId,
							exportXml: 3
						}
					}else if (this.params.type == 1 || this.params.type == 2) {
						params = {
							offset: this.claimlisttotal + 1,
							page: 0,
							shopIds: this.shopIdlist,
							type: this.params.type,
							userId: this.userId,
							exportXml: 3
						}
					}
					this.getReturnOrder(params)
				}else{
					let arr = this.multipleSelection
					let csvlist = []
					if (!arr.length) {
						this.$message.error(this.$t('other.a152'))
						return
					}
					arr.forEach(p => {
						csvlist.push(p)
					})
					let ttp = csvlist.map(p => {
						return {
							'订单号': p.orderId,
							'退货原因': p.returnCause,
							'金额': p.returnAmount,
							'下单时间': p.createTime,
                            '状态':desc[this.params.type]
						}

					})

                   
					utils.exportExcel_Claim(ttp)
				}
			},

            //控制每页显示订单条数
			 handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.offset=parseInt(`${val}`)
				this.params.offset=parseInt(`${val}`)
            
				this.handleCurrentChange()
			},
			//显示当前第几页
			handleCurrentChange(val) {
				this.currentPage1=parseInt(`${val}`)
                this.params.page=!this.params.page ? (parseInt(`${val}`)-1)*this.params.offset : 0
				console.log(this.params)
				this.getReturnOrder(this.params)
			},


			getPonit(){
				this.getSellerPoint({
					userId:this.userId
				})
			},
			setSecondPWS(){
			
				api
				.setSecPws({userId:this.userId,password:this.secondPws})
				.then(res => {
					if(res.code == 200){
						this.$confirm(this.$t('other.a1817'), this.$t("other.a142"), {
						confirmButtonText: this.$t('other.a729'),
						type: 'success'
						}).then(() => {
							this.SecondPWSVisible=false
							let obj=JSON.parse(localStorage.getItem('userInfo'))
							obj.hasSecPw=true
							localStorage.setItem('userInfo',JSON.stringify(obj))
							location.reload()

						})
					}else{
						this.$message.error(res.msg)
					}
				})	
			},
			
			f1(){
				let promise=new Promise((resovle,reject) => {
					let num = Math.random()*6
					setTimeout(() => {
						resovle(num)
					},1000)
				})
				return promise
			},
			async f2(){
				
				let T=null
				let n=await this.f1()
				console.log(n)
				console.log(T)
				
				
				
			},

            viewLogistics01(item) {
				console.log(item)
				let params = {
					ordersn: item.orderId,
					shopId: item.shopId
				}
				this.viewLogistics(params)
				this.LogisticsWindow = true
			},
			
			
			gotopersonal(){
				const {href}=this.$router.resolve({
					path:'/personal-account',
					query:{
						key:'resetSecondPws'
					}
				
				}) 
				window.open(href)
			},
			
		
			closePage(){
		
				localStorage.removeItem('secondPws')
				this.RESET_SECOND_PASSWORD()
				this.kilogram=''
			},
			
			comfirm(){
				
			
				this.verifySecondyPassword({
					userAccount:this.userId,
					verifyPassword:this.kilogram
				})
				
				console.log(this.secondPassword)
				
			},
			
			returnCause(ttp){
				const status={
					LOST_PARCEL:this.$t("other.a114"),
					LOGISTICS_DELIVERY_FAILED:this.$t("other.a115")

				}
				return status[ttp]
			},
			
		
			otnmgv(){
				let newUrl=location.href
				
				let arr=newUrl.split(/=/)
				let shopid=parseInt(arr[arr.length-1])
				console.log('shopid',shopid)
				const params= {
					userId:this.userId,
					shopId:shopid
				}
				console.log(params)
			
				
				 if(newUrl.search("shop_id") == -1){
					 console.log(typeof(shopid))
					  return
				 }else {
					 console.log(params)
					 this.getLockShopID(params)
					 this.$router.push('./index')
				 }
				 
				
				
			},
			
			
			//刷新页面
			updataPage(){
				this.getClaim()
			},
			//查看索赔的订单
			viewMore(num){
				
				if(num === 0) {
					this.params.type=0
				}else if(num === 1) {
					this.params.type=1
				}else if(num === 2) {
					this.params.type=2
				}
				this.getReturnOrder(this.params)
			},
            remainTime(time) {
				return utils.cancelOrderTime(time, 30)
			},
			//获取索赔的订单
			getClaim(){
				this.params.userId=this.userId
				this.params.shopIds=this.allshopId
                let arr=[{
					offset:50,
					page:0,
					shopIds:this.allshopId,
					type:0,
					userId:this.userId,
				},{
					offset:50,
					page:0,
					shopIds:this.allshopId,
					type:1,
					userId:this.userId,
				},{
					offset:50,
					page:0,
					shopIds:this.allshopId,
					type:2,
					userId:this.userId,
				}]
				arr.forEach(p => {
					this.getReturnOrder(p)
				})
			},
            showShopName(id){
                return utils.showshopNameByshopIdOne(id)
            },

            getClaimOrder(){
                console.log(this.storesvalue)
                if(this.storesvalue == '') {
                    this.params.shopIds=this.allshopId
                }else{
                    this.params.shopIds=[this.storesvalue]
                }

                this.getReturnOrder(this.params)

            },

            getClaimOrderCopy(){
                this.params.type=this.returnCasuevalue
                this.getReturnOrder(this.params)

            },
			
			getSalesBytime(){
				console.log(this.value4)
				this.getOpp()
			},
			
			getSales(){
				
				console.log(this.onlyStoreItem)
				this.getOpp()
			},
			
			getCargovalueByStore(){
				
				let arr=this.warehouse.map(p => {
					return {
						storeId:p.storeId,
						userId:this.userId
					}
				})
				
				console.log(arr)
				arr.forEach(k => {
					this.getCargovalueStore(k)
				})
				
			},
			
			getOpp(){
				this.GET_TTO_CCP()
				
				
				this.shopeeShoplist.forEach(p => {
					this.getShopSale({
						end:this.value4[1],
						start:this.value4[0],
						onlyStoreItem:this.onlyStoreItem,
						shopId:p.shopId,
						shopName:p.shopName,
						userId:this.userId
					})
				})
			
				
				// this.warehouse.forEach(k => {
				// 	this.getStoreSale({
				// 		end:this.value4[1],
				// 		start:this.value4[0],
				// 		userId:this.userId,
				// 		storeName:k.storeName,
				// 		storeId:k.storeId
				// 	})
				// })
			},
			
			init(){
				console.log(this.$refs.mark)
				let start=utils.getRecentSevenDay(-30)
				let end=utils.getRecentSevenDay(0)
				this.value4=[start,end]
				this.storesvalue=''
				let allshopId=utils.getAllshop().map(p => {
					return p.value
				})
				
				let ttp=JSON.parse(localStorage.getItem('userInfo'))
				this.showPage=ttp.secondPassword
				
				allshopId.splice(0,1)
				this.allshopId=allshopId
			},
			

            returnCause(ttp) {
				const status = {
					'LOST_PARCEL': this.$t("other.a114"),
					'LOGISTICS_DELIVERY_FAILED': this.$t("other.a115"),
					'Failed Delivery':this.$t("other.a115"),
					'LOST_PARCEL':this.$t("other.a114"),
					'Parcel lost in transit. The eligible compensation has been credited into your seller wallet.':this.$t("other.a114"),
					'LOGISTICS_ISSUE':this.$t("other.a139"),
					'Logistic Issue':this.$t("other.a139"),
					'Delivery service provider reported that the parcel has been lost.':this.$t("other.a114"),
					'FRAUD_CASE':'FRAUD_CASE',
					'':this.$t("other.a140"),
					
					
					
				}
				return status[ttp]
			},

            getTime(time) {

				if (time == null) {
					return '--'
				}
				return utils.renderTime(time)
			},
			
			
			
			getppc(){
				this.allShopSales.forEach(p => {
					if(p.shopName === this.shopName) {
						this.chartsline= echarts.init(document.getElementById(this.shopName));
											
						this.chartsline.setOption(p.option)
					}
				})
				
			},
			getppc01(){
				this.allWarehouseSales.forEach(k => {
					if(k.storeName === this.storeName) {
						this.chartsline = echarts.init(document.getElementById(this.storeName));
						this.chartsline.setOption(k.option)
					}
				})
			},
			//获取两个日期间 的天数
			getDaysBetween(){
				
				let ttp=this.value4[0]
				let ccp=this.value4[1]
			   var  startDate = Date.parse(ttp);
			   var  endDate = Date.parse(ccp);
			   var days=(endDate - startDate)/(1*24*60*60*1000);
			  this.days01=days;
			 
			},
			getSaleAVG(item) {
				let ttp=item.sales/this.days01
				return ttp.toFixed(2)
			},
            handleSelectionChange(val) {
		
				this.multipleSelection = val;
				console.log(this.multipleSelection)
			},
			gestoreAVG(item) {
				let ttp=item.sales/this.days01
				return ttp.toFixed(2)
			},
			viewSales(item){
				this.salesVisible=true
				this.shopName=item.shopName
				
				setTimeout(() => {
					this.getppc()
				},200)
				
			},
			viewSalesStore(item){
				console.log(item)
				this.salesVisible01=true
				this.storeName=item.storeName
				
				setTimeout(() => {
					this.getppc01()
				},200)
			}
		},
	
	}
</script>

<style>
	.claimOrder{
		/* flex: 1;
		margin: 50px 0 0 221px; */
		
		
	}
	.claimOrder .home-box{
		background-color: rgba(50,50,50,.1);
        margin-bottom: 70px;
        
	}

	.claimOrder .titl_desc_tip{
		display: flex;
		background-color: #fff;
	
		margin-bottom: 30px;
	}

	.claimOrder .titl_desc_tip_right{
		display: flex;
    flex-direction: column;
    justify-content: space-around;
    box-sizing: border-box;
    padding: 10px 15px;
	}

	.claimOrder .el-tooltip__popper{
		font-size: 16px!important;
	}

	
	.claimOrder .home-wrapper{
		flex: 1;
		margin: 50px 0 0 221px;
	}
	
	.claimOrder .home-title{
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: 60px;
		background-color: #fff;
	
		margin-bottom: 10px;
		padding:0 20px 0 0;
		
	}
	
	.claimOrder .line-box{
		width: 700px;
		height: 300px; 
		background-color: #fff;
		border-radius: 10px;
	}
	
/* 	.home-wrapper{
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		margin-bottom: 20px;
	}
	 */
	.claimOrder .home-box-ttp{
		display: flex;
		justify-content: space-around;
		padding: 10px;
		margin-bottom: 30px;
		
	}
	
	.claimOrder .warpper-box{
		display: flex;
		    justify-content: center;
	}
	
	.claimOrder .home-box-item{
		width: 400px;
		height: 220px;
		font-size: 22px;
		background-color: #fff;
		border-radius: 10px;
		
	}
	
	.claimOrder .home-box-item-childern{
		width: 400px;
		height: 125px;
		background-color: #fff;
		border-radius: 10px;
        cursor: pointer;
        position: relative;
	}

    .claimOrder .home-box-item-childern-active:after{
       content: '';
		width: 400px;
		height: 4px;
        background-color: blue;
        position: absolute;
        bottom: 0;
		box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
		
	}

	.claimOrder .home-box-item-childern-active{
		transform: scale(1.08);
		transition: all 0.8s;
		
	}


	.claimOrder .home-box-item-childern-header{
		display: flex;
		justify-content: space-between;
		border-bottom: #eee 1px solid;
		align-items: center;
		height: 50px;
		line-height: 50px;
		box-sizing: border-box;
		padding: 0 10px;
	}
	.claimOrder .home-box-item-childern-content{
		font-size: 18px;
		margin-top: 15px;
		box-sizing: border-box;
		padding: 0 10px;
		
	}
	.claimOrder .item-header{
		display: flex;
		justify-content: space-between;
		border-bottom: #eee 1px solid;
		align-items: center;
		height: 50px;
		line-height: 50px;
		box-sizing: border-box;
		padding: 0 10px;
	}
	.claimOrder .item-content{
		display: flex;
		flex-direction: column;
		justify-content: center;
		height: 100px;
		box-sizing: border-box;
		padding: 0 10px;
		border-bottom: #eee 1px solid;
	}
	
	.claimOrder .item-header-right{
		font-size: 14px;
		background-color: #008161;
		height: 30px;
		padding: 0 10px;
		color: #fff;
		line-height: 30px;
		border-radius: 5px;
		cursor: pointer;
	}
	.claimOrder .item-header-right01{
		font-size: 16px;
		background-color: orange;
		height: 30px;
		padding: 0 10px;
		color: #fff;
		line-height: 30px;
		border-radius: 5px;
		margin-left: 5px;
	}
	
	.claimOrder .item-footer{
		box-sizing: border-box;
		padding: 0 10px;
	}
	
	.claimOrder .shop-sales{
		border-radius: 5px;
		box-sizing: border-box;
		padding: 0 10px;
		margin: 0 15px 30px 15px;
		background-color: #fff;
	}
	.claimOrder .sales-content-title{
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: 1px #eee solid;
		
	}
	
	.claimOrder .sales-content-title-item{
		display: inline-block;
		width: 190px;
		
		padding-bottom: 10px;
		text-align: center;
		
	}
	.claimOrder .sales-content-title-item:nth-child(1) {
		width: 250px;
	}

    .claimOrder .Pager{
		position: fixed;
		bottom: 0;
		left: 225px;
		right: 0;
		height: 40px;
		line-height: 40px;
		background-color: #fff;
		text-align:right;
        z-index: 888;
	}
	
	.claimOrder .shop-sales-header{
		margin-bottom: 15px;
	}
	
	.claimOrder .store-item{
		height: 60px;
		line-height: 60px;
	}
	
/* 	.home .el-input__inner{
		width: 170px;
		border: none!important;
	}
	.home .el-input--mini{
		width: 170px!important;
	} */
</style>
